<script setup lang="ts">
import { PropType } from 'vue'

/* Types */
import { Address } from '~/types/store/addresses'

const props = defineProps({
  address: {
    required: true,
    type: Object as PropType<Address>,
  },
})
</script>

<template>
  <div class="address-item">
    <div class="address-wrapper">
      <div class="address">
        {{ props.address.fullAddress }}
      </div>
    </div>

    <div v-if="props.address.city" class="address-item__city">
      город {{ props.address.city }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.address-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  &__city {
    font-size: 12px;
    font-weight: 600;
    color: $dark-grey;
  }
}
.address {
  font-size: 14px;
  font-weight: 600;
  color: $text-black;
}
.address-wrapper {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-right: 40px;

  @include media('<portrait-phone') {
    margin-right: 14px;
  }
}
</style>
